import React from 'react';
import SimplrDropdown from '../../../DropDown/SimplrDropdown/SimplrDropdown';
import { ToggleSwitch } from '../../../common/toggleComponents';
import { getIdentifierPlaceholder } from '../utils/identifierHelpers';
import { IDENTIFIER_TYPE_OPTIONS } from '../../../../constants/identifierTypes';
import {
  FilterBlock,
  FilterBlockTitle,
  FilterLine,
  FilterLineLabel,
  FilterInput,
  IdentifierInput,
  PartialMatchLine,
  PartialMatchLabel,
} from './IdentifierSearchSection.styles';

export const IdentifierSearchSection = ({
  touchedFields,
  selectedIdentifierType,
  identifierValue,
  partialMatch,
  onIdentifierTypeChange,
  onIdentifierValueChange,
  onIdentifierKeyDown,
  onPartialMatchChange,
}) => {
  return (
    <FilterBlock>
      <FilterBlockTitle>Search by identifiers</FilterBlockTitle>
      <FilterLine>
        <FilterLineLabel>Identifier</FilterLineLabel>
        <FilterInput $isTouched={touchedFields.identifierType}>
          <SimplrDropdown
            selected={selectedIdentifierType}
            options={IDENTIFIER_TYPE_OPTIONS}
            onSelect={onIdentifierTypeChange}
            placeholder="Select identifier"
          />
        </FilterInput>
        <FilterInput $isTouched={touchedFields.identifierValue}>
          <IdentifierInput
            type="text"
            placeholder={getIdentifierPlaceholder(selectedIdentifierType, partialMatch)}
            value={identifierValue}
            onChange={onIdentifierValueChange}
            onKeyDown={onIdentifierKeyDown}
            disabled={!selectedIdentifierType}
          />
        </FilterInput>
      </FilterLine>
      <PartialMatchLine>
        <PartialMatchLabel>
          Partial match (starts-with)
          <ToggleSwitch checked={partialMatch} onChange={onPartialMatchChange} />
        </PartialMatchLabel>
      </PartialMatchLine>
    </FilterBlock>
  );
};
